import {TheRaveGameAssets} from "../TheRaveGameAssets";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {BitmapTextStyleOptions} from "../coutup/BitmapCountUp";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";

export class FontStyleConfig {
    public static readonly WAYS_NORMAL: BitmapTextStyleOptions = {
        fontName: TheRaveGameAssets.BITMAP_FONT_WAYS,
        fontSize: 15,
        maxWidth:200
    };


    public static readonly WAYS_GLOW: BitmapTextStyleOptions = {
        fontName: TheRaveGameAssets.BITMAP_FONT_SUPERFS_GLOW_MUL,
        fontSize: 30,
        tint: 0xffffff
    };

    public static readonly MULTIPLIER_M1_FS: BitmapTextStyleOptions = {
        fontName: TheRaveGameAssets.BITMAP_FONT_WAYS,
        fontSize: 14,
    };

    public static readonly SYMBOL_MULTIPLIER: BitmapTextStyleOptions = {
        fontName : TheRaveGameAssets.BITMAP_FONT_SYMBOL_MULTIPLIER,
        fontSize : 30
    };

    public static readonly ENHANCER_MULTIPLIER: BitmapTextStyleOptions = {
        fontName : TheRaveGameAssets.BITMAP_FONT_SYMBOL_MULTIPLIER,
        fontSize : 15
    };

    public static readonly COUNT_UP_INITIAL_WIN: BitmapTextStyleOptions = {
        fontName : TheRaveGameAssets.BITMAP_FONT_WIN_COUNT_UP,
        fontSize : 60,
        tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    public static readonly COUNT_UP_BIG_WIN: BitmapTextStyleOptions = {
        fontName : TheRaveGameAssets.BITMAP_FONT_WIN_COUNT_UP,
        fontSize : 120,
        tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    public static readonly COUNT_UP_FS_OUTRO: BitmapTextStyleOptions = {
        fontName : TheRaveGameAssets.BITMAP_FONT_WIN_COUNT_UP,
        fontSize : 70,
        tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    public static readonly COUNT_UP_MAX_CAP: BitmapTextStyleOptions = {
        fontName : TheRaveGameAssets.BITMAP_FONT_WIN_COUNT_UP,
        fontSize : 60,
        tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    public static readonly FS_INTRO_NUMBER_FS: BitmapTextStyleOptions = {
        fontName: TheRaveGameAssets.BITMAP_FONT_FS_INTRO_NUMBER_FS,
        fontSize: 35,
        tint: 0xffffff
    };

    public static readonly WAYS_WON: PIXI.TextStyle = new PIXI.TextStyle({
        fontFamily : OpenSans.FAMILY,
        fontWeight : FontWeight.BOLD,
        fontSize : 34,
        dropShadow:true,
        dropShadowAngle: 1.8,
        dropShadowBlur: 10,
        lineJoin: "round",
        dropShadowColor: "#120202",
        dropShadowDistance: 8,
        fill: "white",
        fillGradientType: 1,
        padding: 4,
        strokeThickness: 10
    });
}
